import { inject, Injectable } from '@angular/core';
import { AppState, Theme } from './app.state';
import * as Actions from './app.actions';
import { select, Store } from '@ngxs/store';

@Injectable()
export class AppFacade {
  private store = inject(Store);
  public theme$ = select(AppState.theme);
  public setTheme(theme: Theme) {
    this.store.dispatch(new Actions.SetTheme(theme));
  }
}